export class Ajax {
	constructor(baseConfig = {}) {
		this.defaultConfig = {
			url: '/ajax.php',
			method: 'POST',
			dataType: 'json',
			...baseConfig
		};
		
		this.activeRequests = [];
	}

	/**
	 * Базовый метод для выполнения запросов
	 * @param {Object} config - Конфигурация запроса
	 * @returns {Promise} - Промис с результатом запроса
	 */
	request(config) {
		// Для FormData не нужно объединять данные
		const mergedConfig = {
			...this.defaultConfig,
			...config,
		};

		// Если данные - объект (не FormData), объединяем с дефолтными
		if (!(config.data instanceof FormData)) {
			mergedConfig.data = {
				...this.defaultConfig.data,
				...config.data
			};
		}

		// Автоматически выставляем настройки для FormData
		if (mergedConfig.data instanceof FormData) {
			mergedConfig.processData = false;
			mergedConfig.contentType = false;
		}

		const jqXHR = $.ajax(mergedConfig)
			.fail(error => this.handleError(error, mergedConfig));

		this.activeRequests.push(jqXHR);
		return jqXHR;
	}

	/**
	 * GET-запрос
	 * @param {String} url - URL запроса
	 * @param {Object} data - Данные для отправки
	 * @param {Object} config - Дополнительная конфигурация
	 */
	get(url, data = {}, config = {}) {
		return this.request({
			method: 'GET',
			url,
			data,
			...config
		});
	}

	/**
	 * POST-запрос
	 * @param {String} url - URL запроса
	 * @param {Object} data - Данные для отправки
	 * @param {Object} config - Дополнительная конфигурация
	 */
	post(url, data = {}, config = {}) {
		return this.request({
			method: 'POST',
			url,
			data,
			...config
		});
	}

	/**
	 * Обработчик ошибок
	 * @param {Object} error - Объект ошибки
	 * @param {Object} config - Конфигурация запроса
	 */
	handleError(error, config) {
		if (error.statusText === 'abort') {
			console.warn('Request aborted:', config.url);
			return;
		}
		
		const defaultHandler = () => {
			//alert(`Error: ${error.statusText || 'Unknown error'}`);
			console.log(`Error: ${error.statusText || 'Unknown error'}`);
		};
		
		(config.error || defaultHandler)();
	}

	/**
	 * Отмена всех активных запросов
	 */
	abortAll() {
		this.activeRequests.forEach(xhr => xhr.abort());
		this.activeRequests = [];
	}
}